/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Reverse_Five_FramesInputs */



/**
* | output |
* | --- |
* | "Go back five frames in the video" |
*
* @param {Shortcut_Keys_Desc_Reverse_Five_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_reverse_five_frames = /** @type {((inputs?: Shortcut_Keys_Desc_Reverse_Five_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Reverse_Five_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reculer de cinq images dans la video")
	if (locale === "de") return /** @type {LocalizedString} */ ("Spule im Video fünf Frames zurück.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Torna indietro di cinque fotogrammi nel video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вернитесь на пять кадров назад в видео.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Retroceda cinco fotogramas en el vídeo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频倒回前五帧。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビデオを5フレーム前に戻す")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो में पांच फ्रेम पीछे जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Volte cinco frames no vídeo.")
	return /** @type {LocalizedString} */ ("Go back five frames in the video")
});